import { IonCheckbox, IonPage, IonButton, IonCardContent, IonContent, IonInput, IonItem, IonCard, IonAlert, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import React, {useState, useContext, useEffect} from 'react';
import { useParams } from "react-router-dom"
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Auth.css';
import { ServerUrl } from '../../constants';
import { Redirect } from 'react-router-dom';
import { AppContext } from "../../context/appContext";
import { VerifyPassword } from '../../constants';

const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const  EditAccount: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);

  let params: any = useParams();
  let userId = parseInt(params.id);

  const [firstname, setFirstname] = useState<string>('');
  const [lastname, setLastname] = useState<string>('');
  const [username, setUsername] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [groups, setGroups] = useState<Array<any>>();
  const [region, setRegion] =useState<string>();
  const [role, setRole] =useState<string>();
  const [messageText, setMessageText] = useState<string>('');
  const [registered, setRegistered] = useState(false);
  const [activated, setActivated] = useState(false);

  useEffect(() => {
    if (userId) {
      axios.get(`${ServerUrl}/auth/getUser?id=${userId}`, {
        headers: {
          'Authorization': "Bearer " + CurrentUser.token,          
        }
      }).then(res => {
        setFirstname(res.data.firstname);
        setLastname(res.data.lastname);
        setUsername(res.data.username);
        setEmail(res.data.email);
        setRegion(res.data.group);
        setRole(res.data.role);
        setActivated(res.data.activated);
      })
      axios.get(`${ServerUrl}/auth/getGroups`).then(res => setGroups(res.data))
    }
  }, [CurrentUser.token, userId]);

  if (registered) {
    return <Redirect to="/" />
  }

  const onUpdateAccount = ()=> {
    var errorMessage = '';
    if (!email || !mailformat.test(email)) {
      errorMessage += 'Email is invalid<br>';      
    }
    if (!username || username.length < 6) {
      errorMessage += 'Username must have 6 characters or more.<br>'
    }
    if (password) {
      if (password !== confirmPassword || password.length < 8) {
        errorMessage += 'Password must have 8 characters or more.<br>'
      } else {
        if (!VerifyPassword(password)) {
          errorMessage += 'Password must contain at least one numeric digit and a special character, and has more than 7 characters.';
        }
      }
    }
    if (!region) {
      errorMessage += "Region is required";
    }     
    if (!role) {
      errorMessage += "Role is required";
    }    

    if (errorMessage.length > 0) {
      setMessageText(errorMessage);
      return;
    }

    axios.post(`${ServerUrl}/auth/updateuser`, {"Id": userId, username, password, email, firstname, lastname, role, activated, groupId: region}, {
      headers: {
        'Authorization': "Bearer " + CurrentUser.token,          
      }
    }).then(res => {
      setRegistered(true);
    }).catch((error) => {
      setMessageText(error.response.data);  
    });

    // axios.post(`${ServerUrl}/auth/updateuser`, {id: userId, username, password, email, firstname, lastname, groupId: region, role, activated}, {
    //   headers: {
    //     'Authorization': "Bearer " + CurrentUser.token,          
    //   }
    // }).then(res => {
    //   setRegistered(true);
    // }).catch((error) => {
    //   setMessageText(error.response.data);  
    // });

  };

  return(
      <IonPage>
          <Navbar />
          <IonContent>
          <div className='Container'>
            <div className='PageTitle'>Edit User {userId}</div>
            <IonCard>
              <IonCardContent>
                <IonItem className="FirstTextInput">
                    <IonInput min='0'  value={username} placeholder="Username" 
                        onIonChange={e => setUsername(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <IonItem className="TextInput">
                    <IonInput min='0'  type="password" value={password} placeholder="Password" 
                        onIonChange={e => setPassword(e.detail.value!)}>
                    </IonInput>
                </IonItem >
                <IonItem className="TextInput">
                    <IonInput min='0'  type="password" value={confirmPassword} placeholder="Confirm Password" 
                        onIonChange={e => setConfirmPassword(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <IonItem className="TextInput">
                    <IonInput min='0'  value={firstname} placeholder="First name" 
                        onIonChange={e => setFirstname(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <IonItem className="TextInput">
                    <IonInput min='0'  value={lastname} placeholder="Last name" 
                        onIonChange={e => setLastname(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <IonItem className="TextInput">
                    <IonInput min='0'  value={email} placeholder="Email" 
                        onIonChange={e => setEmail(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel>Region</IonLabel>
                  <IonSelect placeholder="Select a region" value={region} onIonChange={(e) => setRegion((e.target as HTMLInputElement).value)}>
                    {groups && groups.map((group, index) => <IonSelectOption key={index} value={group.id}>{group.name}</IonSelectOption>)}
                  </IonSelect>
                </IonItem>
                <IonItem>
                  <IonLabel>Role</IonLabel>
                  <IonSelect placeholder="Select a role" value={role} onIonChange={(e) => setRole((e.target as HTMLInputElement).value)}>
                    <IonSelectOption value="admin">Admin</IonSelectOption>
                    <IonSelectOption value="user">User</IonSelectOption>
                  </IonSelect>
                </IonItem>
                <IonItem>
                  <div style={{display: 'flex', justifyContent:'space-between', width: '100%', alignItems: 'center'}}>
                  <div>Activated</div>
                  <IonCheckbox
                    checked={activated}
                    onIonChange={() => setActivated(!activated)}
                  />
                  </div>
                </IonItem>
                <div className='RowCenter'>
                  <IonButton color="primary" style={{textTransform:'none'}} onClick = {onUpdateAccount}>Update</IonButton>
                </div>
              </IonCardContent>
            </IonCard>
          </div>
          <IonAlert 
              isOpen={messageText.length > 0} 
              onDidDismiss={()=> setMessageText('')}
              header={'Error'}
              subHeader={''}
              message={messageText}
              buttons={['OK']}
          />
          </IonContent>
      </IonPage>
  );
};

export default  EditAccount;
